import { useQuery } from '@tanstack/react-query'
import { getModels } from '../api/data-connectors/get-models'
import { buildModelOptions } from '../utils'

export const MODELS_QUERY_KEY = ['models'] as const
const MODELS_STALE_TIME = 86_400_000 // 1 day

export function useGetModels(enabled?: boolean) {
  return useQuery({
    queryKey: MODELS_QUERY_KEY,
    queryFn: () => getModels(),
    staleTime: MODELS_STALE_TIME,
    select: buildModelOptions,
    enabled,
    // Prevents re-fetching when a second subscriber mounts (e.g. AppShell) while
    // the query is already in error state — the retry from ProtectedRoute is enough.
    retryOnMount: false,
  })
}
